import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import Breadcrumbs from "../core/Breadcrumbs";
import {
  getCommissionConfig,
  updateCommissionConfig,
} from "../../libs/commission_calculator";
import CommissionConfigForm from "./CommissionConfigForm";
import Panel from "../core/Panel";
import { clone } from "lodash";
import Card from "../core/Card";
import { toast } from "../../utils";

interface IProps extends RouteComponentProps<{ configId: string }> {}

interface IState {
  commissionConfig?: ICommissionConfig;
  loading: boolean;
}

class CommissionConfig extends React.Component<IProps, IState> {
  state: Readonly<IState> = { loading: true };

  async componentDidMount() {
    const configId = this.props.match.params.configId;
    const commissionConfig = await getCommissionConfig(configId);
    this.setState({ loading: false, commissionConfig });
  }

  updateConfig = async configAttrs => {
    const config = clone(this.state.commissionConfig);
    Object.assign(config, configAttrs);
    const newConfig = await updateCommissionConfig(config);
    this.setState({ commissionConfig: newConfig });
    toast.success("Config saved.");
  };

  render() {
    const { loading, commissionConfig } = this.state;
    return (
      <>
        <Breadcrumbs
          crumbs={[
            {
              label: "Commission Calculator",
              routerLink: true,
              route: "/",
            },
            {
              label: "Configurations",
              routerLink: true,
              route: "/configs",
            },
            { label: loading ? "..." : commissionConfig!.name },
          ]}
        />
        <Card title={"Editing Commission Configuration"}>
          {commissionConfig && (
            <CommissionConfigForm
              config={commissionConfig}
              onChange={this.updateConfig}
            />
          )}
        </Card>
      </>
    );
  }
}

export default CommissionConfig;



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/CommissionConfig.tsx